/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ConnectionFineIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACPUlEQVR4nN2Uu2sUcRDHV41Y+KhiY5eb2TsRUc5gKQc+ULydWUGvE7EQWx+1ckkpKczOrMUJaiVIrPwDxBdqIT4KJRaKYAhi1BRq4aOI/O5+v32ZxyW5Rge2mZ3dz+8735mf5/03gUoPQegXCk+D8gtUHkPhM77Ut/cGIPwAlWdme0DpFSif3RI31i0LMtg6ubrcCvohOjQIwsdA6QoKf0hAQp9R6XStWevzehW1Zq0PlQIQupdR9KxykSter6MUhwdB6Y2FfMUopMWZrPwdlMdR6A4IDYMGO4p1xgcQut6B8G8UOrosk0HpNUZ8xJvxVmTrQWkogSgFXUG2jexba3oLGu5HZUWh9ymIH5eFBnIQoWFr/reyBJu9RUezuRKVG6D0zk1RSWh3AdJuFwo/XfJ0VS7wehS6ZVv2E6OglveE31qlp7ozWemyL7y3qAaUoo4S/pRtly9cdwrnXMbZTAblu6XRup9rmVWCwo+yxrvvzcbPazJGXPWFz6HQR/ujaV/CXdl2gdBk5xDB4QQQhWTrX3rdRPtHSjdt379ATOjegYYn7GnHcxtvD1UarW/tCmJa4CBm+ZL8WGMVKE208xFXUzBfm9NsM2bGPFNUUd6USj+wAZSn2ieLgz1pPcVW3ZDL+ULHOwC68Tcgv70TOYjQedvfVvZesvW3XW7gUrDTTtPzeQG26GqqgqvFnpuNd1dJRu1GN8YLA5Snkp+ZRbM3qMuZeXfXRAawxn77Y+E9EHpSfA9K95eS+7fjD3LPf6bzDBezAAAAAElFTkSuQmCC)
 */
export const ConnectionFineIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.STATUS_POSITIVE,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 3a1 1 0 0 1 1-1 19 19 0 0 1 19 19 1 1 0 1 1-2 0A17 17 0 0 0 3 4a1 1 0 0 1-1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2 8a1 1 0 0 1 1-1 14 14 0 0 1 14 14 1 1 0 1 1-2 0A12 12 0 0 0 3 9a1 1 0 0 1-1-1Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 12a1 1 0 1 0 0 2 7 7 0 0 1 7 7 1 1 0 1 0 2 0 9 9 0 0 0-9-9ZM2 17.83c0-.46.37-.83.83-.83C5.13 17 7 18.87 7 21.17c0 .46-.37.83-.83.83H3a1 1 0 0 1-1-1v-3.17Z"
        className={colorClass}
      />
    </svg>
  );
};
